import { breakpoints, defaultTheme } from 'gd-design-library';

const commonHeadingStyles = {
  margin: 0,
  fontWeight: 500
};

export const typography = {
  ...defaultTheme.typography,
  h1: {
    ...defaultTheme.typography.h1,
    ...commonHeadingStyles,
    [`@media (max-width: ${breakpoints.md})`]: {
      fontSize: '34px',
      lineHeight: '38px'
    }
  },
  h2: {
    ...defaultTheme.typography.h2,
    ...commonHeadingStyles,
    [`@media (max-width: ${breakpoints.md})`]: {
      fontSize: '28px',
      lineHeight: '32px'
    }
  },
  h3: {
    ...defaultTheme.typography.h3,
    ...commonHeadingStyles,
    [`@media (max-width: ${breakpoints.md})`]: {
      fontSize: '24px',
      lineHeight: '28px'
    }
  },
  h4: {
    ...defaultTheme.typography.h4,
    ...commonHeadingStyles,
    [`@media (max-width: ${breakpoints.md})`]: {
      fontSize: '20px',
      lineHeight: '24px'
    }
  },
  h5: {
    ...defaultTheme.typography.h5,
    ...commonHeadingStyles,
    [`@media (max-width: ${breakpoints.md})`]: {
      fontSize: '18px',
      lineHeight: '22px'
    }
  },
  h6: {
    ...defaultTheme.typography.h6,
    ...commonHeadingStyles,
    [`@media (max-width: ${breakpoints.md})`]: {
      fontSize: '16px',
      lineHeight: '20px'
    }
  },
  span: {
    ...defaultTheme.typography.span,
    display: 'block',
    lineHeight: '1.4rem'
  },
  strong: {
    ...defaultTheme.typography.strong,
    fontWeight: 500,
    lineHeight: '18px'
  },
  caption: {
    ...defaultTheme.typography.caption,
    lineHeight: '20px'
  }
};
